import React, { Component } from "react";
import { connect } from "react-redux";
import { postData, getData, putData } from "../Core/Projects/action";

type Prop = {
	history: any[],
	postData: any,
	project: any,
};

class Dashboard extends Component<Prop> {
	componentDidMount() {
		const search = Object.fromEntries(new URLSearchParams(window.location.search.substring(1)));
		if (search.slug) {
			delete search.slug;
		}
		this.props.postData(search);
	}

	componentDidUpdate(preProps: any) {
		if (this.props.project && this.props.project.data && preProps.project.data.step !== this.props.project.data.step) {
			this.props.history.push(`/book/${this.props.project.data.step}?slug=${this.props.project.slug}`);
		}
	}

	render() {
		return (
			// <div className="container">
			// 	<div className="row">
			// 		<div className="col-12">
			// 			<div className="custom-box">
			// 			</div>
			// 		</div>
			// 	</div>
			// </div>
			<>
			</>
		);
	}
}

const mapStateToProps = (state: { project: any }) => {
	return {
		project: state.project,
	};
};
export default connect(mapStateToProps, { postData, getData, putData })(Dashboard);
